import styled from 'styled-components';
import { Body2, colors, spacing } from 'ui/theme';
import { WorkflowNode } from '../types';

type Props = {
  workflowId: number;
  workflowName: string;
  workflowNodes: WorkflowNode[];
};

const Li = styled.li`
  list-style-type: disc;
  margin-bottom: ${spacing.threeQuarter};
  margin-left: ${spacing.half};
`;

const WorkflowLink = styled.a`
  color: ${colors.textLink};
`;

export const nodesText = (workflowNodes: WorkflowNode[]) => {
  const nodeIds = workflowNodes.map((node) => `Node ID ${node.id}`);
  return `(${nodeIds.join(', ')})`;
};

export const WorkflowReferenceListItem = ({ workflowId, workflowName, workflowNodes }: Props) => {
  const workflowPath = `/workflows/${workflowId}/edit`;

  return (
    <Li>
      <Body2>
        <WorkflowLink href={workflowPath}>
          <span>{workflowName}</span>
        </WorkflowLink>
        &nbsp;
        <span>{nodesText(workflowNodes)}</span>
      </Body2>
    </Li>
  );
};
